import { useTranslation } from 'react-i18next';
import { Collapse } from 'antd';
import { GetExpandIcon } from '@/utils/commonConfig';

export interface Prop {
  children?: React.ReactNode;
}

export default function CollapseFilters({ children }: Prop) {
  const { t } = useTranslation();

  return (
    <div className="mt-4 py-3 reportFilters bg-[#fff] dark:bg-[#141414]">
      <Collapse
        defaultActiveKey={['1']}
        expandIconPosition="end"
        expandIcon={({ isActive }) => GetExpandIcon(isActive)}
        items={[
          {
            key: '1',
            label: <h3 className="text-[20px] font-medium">{t('filters')}</h3>,
            children: <>{children}</>,
          },
        ]}
      />
    </div>
  );
}
